import { memo, ReactElement } from 'react';
import type { SiteVisitRecordingPhase } from '@store/siteVisitRecordingStore';

interface SiteVisitRecordingTimerDisplayProps {
	displayTime: string;
	phase: SiteVisitRecordingPhase;
	className?: string;
	showStatusDot?: boolean;
}

/** Isolated timer display so pause/resume buttons do not re-render every tick. */
export const SiteVisitRecordingTimerDisplay = memo(function SiteVisitRecordingTimerDisplay({
	displayTime,
	phase,
	className,
	showStatusDot = true,
}: SiteVisitRecordingTimerDisplayProps): ReactElement {
	return (
		<>
			{showStatusDot && (
				<span className="site-visit-recording-controls-status" aria-hidden="true">
					<span className={`site-visit-recording-controls-dot ${phase === 'recording' ? 'is-pulsing' : ''}`} />
				</span>
			)}
			<span className={className ?? 'site-visit-recording-controls-time'}>{displayTime}</span>
		</>
	);
});
